import React, { useRef, useState } from 'react';
import { cameraOutline } from 'ionicons/icons';
import { IonButton, IonIcon } from '@ionic/react';
import logoIcon from '../../assets/foodfight_red_primary_05_downsized.png';
import '../../styles/authentication/ProfilePictureUpload.scss';

function ProfilePictureUpload({ onImageSelect, selectedImage }) {
  const fileInputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleFileSelect = event => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file (JPEG, PNG, etc.)');
        return;
      }
      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        alert('File size must be less than 2MB. Please choose a smaller image.');
        return;
      }

      const img = new Image();
      img.onload = () => {
        const maxDimension = 1024;
        if (img.width > maxDimension || img.height > maxDimension) {
          alert(
            `Image dimensions must be ${maxDimension}x${maxDimension} pixels or smaller. Please resize your image.`,
          );
          return;
        }

        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
        onImageSelect(file);
      };
      img.onerror = () => {
        alert('Unable to load image. Please try a different file.');
      };
      img.src = URL.createObjectURL(file);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const displayImage = selectedImage ? previewUrl : logoIcon;

  return (
    <div className='profile-picture-upload'>
      <div className='profile-picture-container'>
        <img src={displayImage} alt='Profile' className='profile-picture' />
      </div>
      <IonButton className='upload-button' fill='outline' onClick={handleUploadClick}>
        <IonIcon icon={cameraOutline} slot='start' />
        Upload Photo
      </IonButton>
      <p className='upload-hint'>Max 2MB, 1024x1024 pixels</p>
      <input ref={fileInputRef} type='file' accept='image/*' onChange={handleFileSelect} style={{ display: 'none' }} />
    </div>
  );
}

export default ProfilePictureUpload;
